window.dataLayer = window.dataLayer || [];

import { virtualPageview } from '@/scripts/analytics/analytics.methods';

const urlProp = '/virtual/find-my-supplier-cta';
const titleProp = 'Virtual - Find My Supplier';

const elements = [...document.querySelectorAll('.js-supplier-search-cta-ga')];

function bindEventListener(el) {
  el.addEventListener('click', () => virtualPageview(urlProp, titleProp));
}

function init() {
  if (!elements.length) {
    return;
  }

  elements.forEach(bindEventListener);
}

export default init;
